import React, { FC, useRef } from "react";
import PropTypes from "prop-types";
import { LicenseInfo } from "@mui/x-license-pro";

import i18n from "core/i18n";
import { Icon, Typography } from "ui-library/atoms";
import { Box } from "ui-library/layouts";
import { StyledDataTable } from "ui-library/Styled";

LicenseInfo.setLicenseKey("d2aa22429256d6a322ba03220e1d0c14Tz00NDk5NyxFPTE2ODU3OTg0NDUwNjUsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=");

type SimpleTableProps = {
    title: string;
    rows: any;
    detailPanelExpandedRowIds: string[];
    toggleRowCallback: any;
    getRowId: any;
    columns: any;
    headerHeight?: number;
    rowDetail?: boolean;
    getDetailPanelHeight?: any;
};

export const SimpleTable: FC<SimpleTableProps> = ({
    title,
    rows,
    detailPanelExpandedRowIds,
    toggleRowCallback,
    getRowId,
    columns,
    headerHeight = 42,
    rowDetail,
    getDetailPanelHeight,
}) => {
    const baseRef = useRef();

    // determine which columns are hidden
    const hiddenColumns = columns.filter((column) => column.hide);

    // add min width to columns
    columns.forEach((item) => {
        if (!item.minWidth) {
            item.minWidth = 100;
        }
    });

    return (
        <div className="table-wrapper">
            <Typography variant="h4" markDown={title} />
            <StyledDataTable
                ref={baseRef}
                getRowId={getRowId}
                getDetailPanelContent={rowDetail ? ({ row }) => <RowDetail row={row} hiddenColumns={hiddenColumns} /> : null}
                detailPanelExpandedRowIds={detailPanelExpandedRowIds}
                onDetailPanelExpandedRowIdsChange={toggleRowCallback}
                getDetailPanelHeight={({ row }) => (getDetailPanelHeight ? getDetailPanelHeight(row) : 200)}
                getRowClassName={(params) => `${params.row.style ? params.row.style : ""}`}
                pagination={false}
                headerHeight={headerHeight}
                rows={rows}
                autoHeight
                columns={columns}
                disableColumnFilter
                disableColumnMenu
                disableSelectionOnClick
                disableColumnReorder
                hideFooter
                components={{
                    DetailPanelCollapseIcon: CollapseIcon,
                    DetailPanelExpandIcon: ExpandIcon,
                }}
            />
        </div>
    );
};

const RowDetail = ({ row, hiddenColumns }) => (
    <Box>
        {hiddenColumns.map((item) => (
            <div key={item.field}>{item.renderCell(row)}</div>
        ))}
    </Box>
);

RowDetail.propTypes = {
    row: PropTypes.object.isRequired,
    hiddenColumns: PropTypes.array.isRequired,
};

const ExpandIcon = () => <Icon size={14} icon="chevron-down" />;
const CollapseIcon = () => <Icon size={14} icon="chevron-up" />;
